import { render, staticRenderFns } from "./topicCircle.vue?vue&type=template&id=70614b3f&scoped=true&"
import script from "./topicCircle.vue?vue&type=script&lang=js&"
export * from "./topicCircle.vue?vue&type=script&lang=js&"
import style0 from "./topicCircle.vue?vue&type=style&index=0&id=70614b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70614b3f",
  null
  
)

export default component.exports